// test2773
(2773 && 0);
